<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="inspectionTests"
        @select="selectHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="追溯码">
            <el-input v-model.trim="filter.serialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.refBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'startCreateDate', 'endCreateDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="otherBtn">
<!--        <el-button-->
<!--            v-if="addAuth"-->
<!--            type="primary"-->
<!--            :disabled="scope.row.status !== 0"-->
<!--            @click="submitHandle(scope.row)">-->
<!--          提交-->
<!--        </el-button>-->
        <el-upload
            slot="append"
            style="float: left"
            action=""
            :http-request="ImportCustomerFile"
            :disabled="importLoading"
            :show-file-list="false">
          <el-button v-if="limits.uploadAuth"  type="primary" :loading="importLoading">
            上传报告
          </el-button>
        </el-upload>
      </template>
    </view-table>
    <!-- 编辑 -->
    <inspection-Test-edit ref="inspectionTestdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import InspectionTestEdit from "@/views/qm/InspectionTest/InspectionTestEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InspectionTestList",
    components: {
      ViewTable,
      InspectionTestEdit,
    },
    data() {
      return {
        limits: {
          // editAuth: this.$auth(644),
          // addAuth: this.$auth(522),
          delAuth: this.$auth(645),
          uploadAuth: this.$auth(642),
        },
        importLoading: false,
        data: [],
        createDateRange: [],
        filterText: "",
        filter: {
          serialNo: "",
          refBillNo:"",
          materialNo: "",
          materialName: "",
          specification: "",
          creatorName: "",
          startCreateDate: "",
          endCreateDate: "",
        },
        columnsProperty: [
          // {
          //   key: "serialNo",
          //   align: "center",
          //   render: (h, params) => {
          //     return h(
          //         "span",
          //         {
          //           style: {
          //             color: "#2d8cf0",
          //             cursor: "pointer",
          //           },
          //           on: {
          //             click: () => {
          //               this.$refs.inspectionTestdit.open(params.row, true, true);
          //             },
          //           },
          //         },
          //         params.row.no,
          //     );
          //   },
          // },
          {
            key: "filePath",
            tooltip: true,
            width: 120,
            render: (h, params) => {
              return h(
                  "span", {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.download(params.row.filePath);
                      },
                    },
                  },
                  params.row.filePath,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },
    watch: {
      "filter.startCreateDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.startCreateDate);
            this.createDateRange.push(this.filter.endCreateDate);
          }
        },
      },
    },
    methods: {
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        this.$refs.inspectionTestdit.open(row, true, false);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      ImportCustomerFile(params) {
        this.importLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", "inspectionTests/import", formData)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
                this.loadData(1);
              }
              this.importLoading = false;
            })
            .catch(() => {
              this.importLoading = false;
            });
      },

      download(filePath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${filePath}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        this.$http.delete("basic", "inspectionTests", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "inspectionTests/submit/" + row.pkId).then(() => {
            this.loadData(1);
            this.$message.success("提交成功");
            this.selection = [];
          });
        });
      },
      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      // 未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return {
            editAuth: false,
          };
        } else {
          return {
            editAuth: true,
          };
        }
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
